export const enum SizingModels {
    FIXED,
    MAXIMUM,
}
